module.exports = __webpack_public_path__ + "static/media/85390-java-language-text-programming-logo-programmer.93ef244b.png";